import { type SyntheticEvent, useState } from 'react'

import { InputSearchbox } from '@/components/common/Input'
import { usePage } from '@/components/providers/PageProvider'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { cn } from '@/utils/commonUtil'
import { buildRoute } from '@/utils/routeUtil'

import styles from './ArticleListSearch.module.scss'

type Props = {
  size?: 'lg'
}

export const ArticleListSearch = ({ size }: Props) => {
  const { page } = usePage()
  const { redirectUrl } = useLinkInternal()

  const searchRoute = page?.route?.search || ''
  const [search, setSearch] = useState(searchRoute)
  const [searchRouteLast, setSearchRouteLast] = useState(searchRoute)

  if (searchRoute !== searchRouteLast) {
    setSearchRouteLast(searchRoute)
    setSearch(searchRoute)
  }

  const onSubmit = (e: SyntheticEvent<HTMLFormElement, SubmitEvent>) => {
    e.preventDefault()
    if (search) redirectUrl(buildRoute({ search, section: 'articlesSearch' }))
  }

  return (
    <div className={cn(styles.container, { size, styles })}>
      <form onSubmit={onSubmit}>
        <InputSearchbox
          onChange={setSearch}
          onClear={() => setSearch('')}
          placeholder='Search articles...'
          size='lg'
          value={search}
        />
      </form>
    </div>
  )
}
